import {useState} from 'react'
import type {CopilotCodingAgentEligibility} from '../components/copilot-assignment/copilot-assignment-types'

/**
 * Hook to manage Copilot Coding Agent eligibility state and request access dialog
 */
export function useCopilotCodingAgentEligibility(eligibility: CopilotCodingAgentEligibility) {
  const copilotAgentEligibility = eligibility
  const [requestAccessDialogOpen, setRequestAccessDialogOpen] = useState(false)

  const canRequestOrGrantCopilotAgent = !!(
    copilotAgentEligibility.canRequestCca ||
    copilotAgentEligibility.canGrantOrgCca ||
    copilotAgentEligibility.canGrantEnterpriseCca
  )

  const openRequestAccessDialog = () => setRequestAccessDialogOpen(true)
  const closeRequestAccessDialog = () => setRequestAccessDialogOpen(false)

  return {
    copilotAgentEligibility,
    canRequestOrGrantCopilotAgent,
    requestAccessDialogOpen,
    openRequestAccessDialog,
    closeRequestAccessDialog,
  }
}
